var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragHandleSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66179 8.43712C5.64632 8.07017 5.93126 7.76017 6.2982 7.74471C6.66514 7.72925 6.97514 8.01418 6.99061 8.38112C7.00607 8.74807 6.72114 9.05807 6.35419 9.07353C5.98725 9.08899 5.67725 8.80406 5.66179 8.43712Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46574 3.78125C5.45028 3.4143 5.73521 3.1043 6.10215 3.08884C6.4691 3.07338 6.7791 3.35831 6.79456 3.72525C6.81002 4.0922 6.52509 4.4022 6.15815 4.41766C5.7912 4.43312 5.4812 4.14819 5.46574 3.78125Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85856 13.103C5.8431 12.736 6.12803 12.426 6.49498 12.4106C6.86192 12.3951 7.17192 12.68 7.18738 13.047C7.20285 13.4139 6.91791 13.7239 6.55097 13.7394C6.18403 13.7549 5.87402 13.4699 5.85856 13.103Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65837 8.26872C9.64291 7.90178 9.92784 7.59177 10.2948 7.57631C10.6617 7.56085 10.9717 7.84578 10.9872 8.21273C11.0027 8.57967 10.7177 8.88967 10.3508 8.90513C9.98383 8.9206 9.67383 8.63566 9.65837 8.26872Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46208 3.61285C9.44662 3.24591 9.73155 2.93591 10.0985 2.92044C10.4654 2.90498 10.7754 3.18991 10.7909 3.55686C10.8064 3.9238 10.5214 4.2338 10.1545 4.24927C9.78754 4.26473 9.47754 3.97979 9.46208 3.61285Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8549 12.9346C9.83944 12.5676 10.1244 12.2576 10.4913 12.2422C10.8583 12.2267 11.1683 12.5116 11.1837 12.8786C11.1992 13.2455 10.9143 13.5555 10.5473 13.571C10.1804 13.5865 9.87036 13.3015 9.8549 12.9346Z",
    fill: "#CBD5E1",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandleSvg);
export default __webpack_public_path__ + "static/media/DragHandleSvg.ebcb6ebabf3c10b8ae0978940425e99f.svg";
export { ForwardRef as ReactComponent };